var _feGaussianBlur;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCassiopeiaBadgeFullHeart = function SvgCassiopeiaBadgeFullHeart(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 44.264,
    height: 58.413,
    viewBox: "0 0 28.329 37.384",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    width: 1.256,
    height: 1.183,
    x: -0.128,
    y: -0.091,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feGaussianBlur || (_feGaussianBlur = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.904
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M61.043.873a3.938 3.938 0 0 0-3.934 3.934 3.94 3.94 0 0 0 3.149 3.853v10.412a12.24 12.24 0 0 0-4.654 2.924 12.204 12.204 0 0 0-3.598 8.688 12.2 12.2 0 0 0 3.598 8.685l9.562 9.563a6.583 6.583 0 0 0 4.688 1.941c1.77 0 3.436-.689 4.689-1.941l9.562-9.563a12.2 12.2 0 0 0 3.598-8.685c0-3.282-1.277-6.367-3.598-8.688a12.244 12.244 0 0 0-4.654-2.924V8.66A3.94 3.94 0 0 0 82.6 4.807 3.938 3.938 0 0 0 78.666.873Zm0 3.148zm17.623 0ZM64.291 18.396zm0 0zm11.127 0zm0 0zm-7.781.463zm1.836 2.442z",
    style: {
      opacity: 0.599975,
      mixBlendMode: "normal",
      fill: "#000",
      fillOpacity: 1,
      strokeWidth: 0.0976567,
      filter: "url(#a)"
    },
    transform: "matrix(.57395 -.04668 .05469 .67248 -27.535 2.663)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m293.926 226.135-69.91 69.906c-6.983 6.985-16.27 10.831-26.147 10.831v5.75l-.002-5.75c-9.88 0-19.165-3.846-26.147-10.832l-69.904-69.905c-14.793-14.793-22.94-34.46-22.94-55.381 0-20.922 8.148-40.59 22.942-55.383 14.79-14.792 34.459-22.94 55.38-22.94 13.303 0 26.404 3.365 37.886 9.73a5.75 5.75 0 0 0 5.575 0c11.481-6.366 24.582-9.73 37.886-9.73 20.92 0 40.589 8.148 55.383 22.941 14.793 14.793 22.94 34.461 22.94 55.382 0 20.92-8.149 40.588-22.942 55.381z",
    style: {
      fill: "#d4aa00",
      fillOpacity: 1,
      strokeWidth: 0.71396
    },
    transform: "translate(-5.926 4.104) scale(.08754)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.102 124.94c-11.95-11.95-27.838-18.53-44.738-18.53-15.05 0-29.296 5.218-40.673 14.798-11.379-9.58-25.626-14.799-40.674-14.799-16.9 0-32.788 6.58-44.737 18.531-11.95 11.949-18.532 27.838-18.532 44.738s6.581 32.79 18.532 44.74l69.904 69.904a21.782 21.782 0 0 0 15.505 6.423 21.789 21.789 0 0 0 15.505-6.422l69.91-69.907c24.666-24.668 24.666-64.806-.002-89.476z",
    style: {
      fill: "#e63128",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 10.4394,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(-5.926 4.104) scale(.08754)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.895 188.878c-10.514 0-19.068 8.554-19.068 19.067 0 10.514 8.554 19.067 19.068 19.067 10.514 0 19.067-8.553 19.067-19.067 0-10.513-8.553-19.067-19.067-19.067zm0 26.638c-4.174 0-7.57-3.396-7.57-7.57s3.396-7.57 7.57-7.57 7.57 3.396 7.57 7.57-3.395 7.57-7.57 7.57z",
    style: {
      fill: "#ff8080",
      strokeWidth: 0.71396
    },
    transform: "translate(-5.926 4.104) scale(.08754)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.088-12.674v96.989a88.897 88.897 0 0 0-16.219 6.312 89.001 89.001 0 0 0-16.218-6.312v-96.989z",
    style: {
      fill: "#1e396b",
      fillOpacity: 1,
      strokeWidth: 0.71396
    },
    transform: "translate(-5.926 4.104) scale(.08754)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.055 107.243c-9.755-9.755-21.36-16.982-34.02-21.37V9.756c13.11-2.67 23.007-14.29 23.007-28.178 0-15.856-12.9-28.755-28.755-28.755H133.453c-15.856 0-28.756 12.9-28.756 28.755 0 13.888 9.896 25.508 23.007 28.178v76.116c-12.661 4.388-24.264 11.615-34.017 21.37-16.966 16.962-26.309 39.519-26.309 63.512 0 23.991 9.342 46.545 26.307 63.51l69.904 69.905c9.153 9.156 21.326 14.199 34.277 14.2h.003c12.948 0 25.121-5.043 34.278-14.199l69.908-69.905c16.966-16.964 26.309-39.52 26.309-63.511 0-23.992-9.344-46.547-26.31-63.511zM116.195-18.422c0-9.516 7.742-17.258 17.259-17.258h128.834c9.516 0 17.258 7.742 17.258 17.258 0 7.502-4.812 13.898-11.51 16.271v-16.27a5.748 5.748 0 0 0-5.748-5.749H133.454a5.748 5.748 0 0 0-5.748 5.748V-2.15c-6.7-2.373-11.511-8.77-11.511-16.27zm140.343 5.748v95.405a90.716 90.716 0 0 0-30.952-.859v-94.546zm-42.45 0v96.989a88.897 88.897 0 0 0-16.219 6.312 89.001 89.001 0 0 0-16.218-6.312v-96.989zm-43.933 0v94.546a90.666 90.666 0 0 0-30.953.859v-95.405zm123.77 238.809-69.908 69.906c-6.984 6.985-16.27 10.831-26.148 10.831v5.75l-.002-5.75c-9.88 0-19.165-3.846-26.147-10.832l-69.904-69.905c-14.793-14.793-22.94-34.46-22.94-55.381 0-20.922 8.148-40.59 22.942-55.383 14.79-14.792 34.459-22.94 55.38-22.94 13.303 0 26.404 3.365 37.886 9.73a5.75 5.75 0 0 0 5.575 0c11.481-6.366 24.582-9.73 37.886-9.73 20.92 0 40.589 8.148 55.383 22.941 14.793 14.793 22.94 34.461 22.94 55.382 0 20.92-8.149 40.588-22.942 55.381z",
    style: {
      strokeWidth: 0.71396
    },
    transform: "translate(-5.926 4.104) scale(.08754)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.256 128.424c-16.697 0-30.282 13.584-30.282 30.282 0 16.697 13.585 30.281 30.282 30.281 16.698 0 30.281-13.584 30.281-30.281 0-16.698-13.583-30.282-30.28-30.282zm0 49.067c-10.359 0-18.785-8.426-18.785-18.784 0-10.36 8.426-18.785 18.785-18.785 10.358 0 18.784 8.426 18.784 18.785 0 10.357-8.426 18.784-18.784 18.784z",
    style: {
      fill: "#ff8080",
      fillOpacity: 1,
      strokeWidth: 0.71396
    },
    transform: "translate(-5.926 4.104) scale(.08754)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.155-12.674v94.546a90.666 90.666 0 0 0-30.953.859v-95.405zm86.383 0v95.405a90.716 90.716 0 0 0-30.952-.859v-94.546z",
    style: {
      fill: "#00925b",
      fillOpacity: 1,
      strokeWidth: 0.71396
    },
    transform: "translate(-5.926 4.104) scale(.08754)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.195-18.422c0-9.516 7.742-17.258 17.259-17.258h128.834c9.516 0 17.258 7.742 17.258 17.258 0 7.502-4.812 13.898-11.51 16.271v-16.27a5.748 5.748 0 0 0-5.748-5.749H133.454a5.748 5.748 0 0 0-5.748 5.748V-2.15c-6.7-2.373-11.511-8.77-11.511-16.27z",
    style: {
      fill: "#fff",
      strokeWidth: 0.71396
    },
    transform: "translate(-5.926 4.104) scale(.08754)"
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCassiopeiaBadgeFullHeart);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/cassiopeia-badge-full-heart.97825ad9ea7c25347d179d2b09e69812.svg";